 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~CurationUploaderAdd~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~Uploader-~980a85e9","1":"vendors~pages-account~pages-admin-redirects~pages-auth-Login~pages-auth-SignUp~pages-auth-VerifyTwoF~d0948b66","2":"vendors~CurationUploaderAdd~CurationUploaderEdit~NationBuilderPreferencesPage~Uploader-DesignUploade~115101c3","3":"vendors~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~activity~fileOverlay-FileOver~4179a708","4":"vendors~activity~components-YourLevelPage~fileOverlay-FileOverlay~files~pages-auth-VerifyTwoFactor-V~a1d347a0","5":"vendors~CurationUploaderAdd~CurationUploaderEdit~Uploader-DesignUploaderOverlayAdd~Uploader-DesignUp~ee48f668","6":"vendors~CurationUploaderAdd~Uploader-DesignUploaderOverlayAdd~activity~components-ProfilePage~files~~5658d979","7":"vendors~FacebookAdPreferences~SquarePreferences~SquarespacePreferences~fileOverlay-FileOverlay~files","8":"vendors~components-PasswordPage~components-PersonalInformationPage~components-ProfessionalBackground~ac0a58b2","9":"FacebookAdPreferences~NationBuilderPreferencesPage~PreziPreferences~SquarePreferences","10":"pages-account~pages-design-disputes-DesignDisputesApp~pages-projects-ProjectsApp~pages-your-work-YourWorkApp","11":"vendors~components-PasswordPage~components-PersonalInformationPage~components-ProfessionalBackground~5190a00c","12":"pages-auth-Login~pages-auth-SignUp~pages-auth-VerifyTwoFactor-VerifyLogin","13":"CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","14":"PasswordStrengthBar","15":"components-PersonalInformationPage~components-ProfessionalBackgroundPage","16":"pages-account~pages-getting-started","17":"vendors~99designs-common-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers~pages-admin-redirects","18":"vendors~CurationUploaderEdit~Uploader-DesignUploaderOverlayEdit","19":"vendors~PasswordStrengthBar","20":"vendors~components-PortfolioPage~components-ProfessionalBackgroundPage","21":"vendors~pages-designer-onboarding-DesignerOnboarderPage~pages-web-get-started-WebOnboarderPage","22":"99designs-common-apps-global-nav-components-GlobalNavDrawers-GlobalNavDrawers","23":"CurationUploaderAdd","24":"CurationUploaderEdit","25":"FacebookAdPreferences","26":"NationBuilderPreferencesPage","27":"PreziPreferences","28":"SquarePreferences","29":"SquarespacePreferences","30":"Uploader-DesignUploaderOverlayAdd","31":"Uploader-DesignUploaderOverlayEdit","32":"activity","33":"components-CurationSamplesPage-CurationSamplesPage","34":"components-NotificationsPage","35":"components-PasswordPage","36":"components-PersonalInformationPage","37":"components-PortfolioPage","38":"components-ProfessionalBackgroundPage","39":"components-ProfilePage","40":"components-TermsPage","41":"components-VerificationPage","42":"components-YourLevelPage","43":"design-transfer-agreement","44":"fileOverlay-FileOverlay","45":"files","47":"overview","48":"pages-account","49":"pages-admin-redirects","50":"pages-auth-Login","51":"pages-auth-SignUp","52":"pages-auth-VerifyTwoFactor-VerifyAddPayout","53":"pages-auth-VerifyTwoFactor-VerifyLogin","54":"pages-create","55":"pages-design-disputes-DesignDisputesApp","56":"pages-designer","57":"pages-designer-onboarding-DesignerOnboarderPage","58":"pages-getting-started","59":"pages-handover-messages","60":"pages-messages","61":"pages-notifications","62":"pages-projects-ProjectsApp","63":"pages-projects-cancel-invites","64":"pages-status","65":"pages-web-get-started-WebOnboarderPage","66":"pages-your-work-YourWorkApp","68":"vendors~PreziPreferences","69":"vendors~SquarespacePreferences","70":"vendors~components-PortfolioPage","71":"vendors~pages-admin-redirects","72":"vendors~pages-design-disputes-DesignDisputesApp","73":"vendors~pages-projects-ProjectsApp","74":"vendors~pages-your-work-YourWorkApp"}[chunkId]||chunkId) + "." + {"0":"3a01fc714a","1":"ae023f0cac","2":"2baf2036e3","3":"750dac1cc5","4":"dce79463a2","5":"8df4818a0b","6":"f77d1a793e","7":"ac4dd6c33c","8":"92a76dd438","9":"cc1617487c","10":"c7a54c5a00","11":"c31f0d82b6","12":"e0a709fefd","13":"44919adb7f","14":"e3679cd163","15":"af4763e1ce","16":"be2a79a2a8","17":"7cb4b99aa1","18":"d9fbfe4243","19":"1dfe27f515","20":"139ba1e871","21":"f2f91d0f65","22":"baa4688884","23":"e1354ed9a5","24":"2ad97e379d","25":"3c3618a17e","26":"c6d810cd72","27":"d78880f86c","28":"32223350e4","29":"b37d0ec0e8","30":"669e4d263d","31":"7105128db8","32":"3b4d0d44c7","33":"35a30aaa37","34":"638164589a","35":"d736e01a15","36":"2ebcb8088e","37":"3d5e6f8e20","38":"012fdc4d79","39":"ecddece4fb","40":"ff7c5f820a","41":"d279b47b26","42":"a78cffaceb","43":"01d3af9bed","44":"b3b268f211","45":"fa02d87619","47":"cbed1d75df","48":"846fd8eee2","49":"8fb38f0791","50":"7ca75e811f","51":"3de4e5f586","52":"0e594b9f7c","53":"57e7675ee4","54":"4a8ee1eead","55":"1d430c53d2","56":"f8ce0f5c62","57":"f8ce8c9b94","58":"bb525f2d2e","59":"5dd59d6a70","60":"08cc52d77d","61":"47099437d8","62":"22500c429d","63":"9e67f259f8","64":"3ddf3b97ba","65":"b6103db471","66":"618d26a979","68":"dfd4e6b9f3","69":"13cc676c78","70":"240bcd905e","71":"c6bd492c58","72":"662dff8bd8","73":"693c8c1d29","74":"ac4d05e187","75":"4a8fe25e0a","76":"d58d4eb405","77":"f89fb033fc","78":"fb047c6270"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/pt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 300);
